export default __webpack_public_path__ + "420378d96fcfb7f08d282280a21be157.png";